
/* injects from baggage-loader */

import { APP_READY, PREFERENCES_SET, PREFERENCES_RESET, PREFERENCES_RESET_ODDS } from './actionTypes/';

/**
 * @description App was ready
 * @returns {Object} new State
 */
export const AppReady = () => {
    return {
        type: APP_READY
    };
};

/**
 * @description Set site preferances
 * @param {String} key
 * @param {*} value
 * @returns {Object} new State
 */
export const PreferencesSet = (key, value) => {
    return {
        type: PREFERENCES_SET,
        key,
        value
    };
};